if (!customElements.get('vbf-accordion-group')) {
  customElements.define(
    'vbf-accordion-group',
    class VbfAccordionGroup extends HTMLElement {

      connectedCallback () {
        this.setupListeners()
      }

      setupListeners () {
        if (!this.els.accordion.exists) return


        this.listeners.add(this, 'click', this.handleTriggerClick.bind(this))
      }

      handleTriggerClick (event) {
        const triggerClicked = event.target
        const parent = triggerClicked.closest(this.els.accordion.selector)

        this.els.accordion.elements.forEach(accordion => {
          if (accordion !== parent) {
            accordion.setAttribute('aria-expanded', 'false')
          }
        })
      }
    },
  )
}
